import { BaseService } from '/@/modules/core/app/services/abstracts/BaseService';

export class BaseTrackingService extends BaseService {
  //
}
